import React, { useState } from 'react';
import { apiFetch } from '../../utils/api';

const ChangePassword = () => {
    const [form, setForm] = useState({ current: '', next: '', confirm: '' });
    const [msg, setMsg] = useState({ type: '', text: '' });

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (form.next.length < 8) return setMsg({ type: 'error', text: 'New password must be at least 8 characters.' });
        if (form.next !== form.confirm) return setMsg({ type: 'error', text: 'Passwords do not match.' });

        const { ok, data } = await apiFetch('/users/password', {
            method: 'PUT',
            body: { currentPassword: form.current, newPassword: form.next },
        });
        if (!ok) return setMsg({ type: 'error', text: data.message || 'Could not change the password.' });

        setMsg({ type: 'ok', text: 'Password changed.' });
        setForm({ current: '', next: '', confirm: '' });
    };

    const field = 'w-full rounded-md border border-gray-200 px-3 py-2.5 text-sm outline-none focus:border-[#2f6b1f]';
    const label = 'mb-1 block text-xs text-gray-500';

    return (
        <>
            <h1 className="text-xl font-semibold">Change Password</h1>
            <form onSubmit={handleSubmit} className="mt-5 max-w-lg space-y-4 rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
                <div>
                    <label htmlFor="current" className={label}>Current Password</label>
                    <input id="current" type="password" name="current" value={form.current} onChange={handleChange} autoComplete="current-password" className={field} />
                </div>
                <div>
                    <label htmlFor="next" className={label}>New Password</label>
                    <input id="next" type="password" name="next" value={form.next} onChange={handleChange} autoComplete="new-password" className={field} />
                </div>
                <div>
                    <label htmlFor="confirm" className={label}>Confirm New Password</label>
                    <input id="confirm" type="password" name="confirm" value={form.confirm} onChange={handleChange} autoComplete="new-password" className={field} />
                </div>
                <button type="submit" className="rounded-md bg-[#2f6b1f] px-6 py-2.5 text-sm font-semibold text-white hover:brightness-110">Update password</button>
                {msg.text && <p role="status" className={`text-xs ${msg.type === 'error' ? 'text-red-600' : 'text-[#2f6b1f]'}`}>{msg.text}</p>}
            </form>
        </>
    );
};

export default ChangePassword;
